import { render, staticRenderFns } from "./EventHistoryCurrencyRateRecalculationParams.vue?vue&type=template&id=4445e408"
import script from "./EventHistoryCurrencyRateRecalculationParams.vue?vue&type=script&lang=js"
export * from "./EventHistoryCurrencyRateRecalculationParams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports